import { ACTIVE_NETWORKS } from '@shared/utils/config/networks';
import { useQuery } from '@tanstack/react-query';
import { Filters } from './historyTypes';
import { queryClient } from '@/pages/_app';
const initialState = {
  network: ACTIVE_NETWORKS,
  txStatusFilter: 'all',
  txTimeFilter: 'all',
  tokenFilter: null,
  txTypeFilter: 'all'
};

// Fetch referral codes and referrals
export const useHistoryFiltersQuery = () => {
  return useQuery({
    queryKey: ['history-filters', initialState],
    queryFn: () => {
      const data: Filters = queryClient.getQueryData(['history-filters']);
      return data || initialState;
    },
    enabled: true,
    refetchOnWindowFocus: false
  });
};